import theTime from "@ishavskraft/the-time";

const timeZoneNorway = { timeZone: "Europe/Oslo" } as const;

const hourMs = 3_600_000;

/** Start of the UTC hour — matches a period's `validOnUtc` exactly, and stays
 *  distinct for the two Norwegian "02" hours of the fall-back day. */
export const hourStartMs = (epochMs: number): number => Math.floor(epochMs / hourMs) * hourMs;

/** Norwegian wall clock at both ends of the hour starting at `validOnUtc`.
 *  The end is the instant an hour later re-read, not `start + 1`, so the
 *  fall-back day reads `02–02` and the spring-forward day `01–03`. */
export const norwayHourRange = (validOnUtc?: string): { start: string; end: string } => {
	const start = theTime(validOnUtc);
	return {
		start: start.to("HH", timeZoneNorway),
		end: start.goes({ HH: 1 }).to("HH", timeZoneNorway),
	};
};

/** `02–03`. Empty when the instant is missing or unreadable. */
export const norwayHourLabel = (validOnUtc?: string): string => {
	const { start, end } = norwayHourRange(validOnUtc);
	return start && end ? `${start}–${end}` : "";
};
